export function transformFromBackendWidget(backendType: any) { // eslint-disable-line
  return {
    name: backendType.name,
    content: typeof backendType.content === "string"? JSON.parse(backendType.content) : {},
  };
}
